import React from 'react';
import DashboardDetail from '../../pages/analysis/DashboardDetail';
import { registerSidePanel } from '../chat/SidePanel';

/**
 * The dashboard kind of side panel.
 *
 * Rendered chromeless: the app shell is already around the conversation, and the
 * panel supplies its own header. Keyed on the dashboard id so switching to a
 * different dashboard remounts rather than leaving the previous one's grid
 * measurements in place.
 */
export const DashboardSidePanel: React.FC<{ id: string; title?: string }> = ({ id }) => (
  <DashboardDetail key={id} embeddedDashboardId={id} chromeless fillParent />
);

export const DASHBOARD_SIDE_PANEL_KIND = 'dashboard';

registerSidePanel(DASHBOARD_SIDE_PANEL_KIND, DashboardSidePanel);
